import { createUseContext } from '@boxcryptor-web/shared/react-hooks';
import React from 'react';
import { ColorScheme, ColorSchemeIdentifier, usePreferredColorScheme } from './color-scheme';

export type Theme = Record<ColorSchemeIdentifier, ColorScheme>;

const ThemeContext = React.createContext<Theme | undefined>(undefined);

export const ThemeProvider: React.FC<{ theme: Theme; children?: React.ReactNode }> = (props) => {
  const { children, theme } = props;
  const colorScheme = usePreferredColorScheme();
  const colors = theme[colorScheme];

  return (
    <ThemeContext.Provider value={theme}>
      <style>{`
      :root {
        --color-brand-50: ${colors.brand[50]};
        --color-brand-100: ${colors.brand[100]};
        --color-brand-200: ${colors.brand[200]};
        --color-brand-300: ${colors.brand[300]};
        --color-brand-400: ${colors.brand[400]};
        --color-brand-500: ${colors.brand[500]};
        --color-brand-600: ${colors.brand[600]};
        --color-brand-700: ${colors.brand[700]};
        --color-brand-800: ${colors.brand[800]};
        --color-brand-900: ${colors.brand[900]};
        --color-gray-50: ${colors.gray[50]};
        --color-gray-100: ${colors.gray[100]};
        --color-gray-200: ${colors.gray[200]};
        --color-gray-300: ${colors.gray[300]};
        --color-gray-400: ${colors.gray[400]};
        --color-gray-500: ${colors.gray[500]};
        --color-gray-600: ${colors.gray[600]};
        --color-gray-700: ${colors.gray[700]};
        --color-gray-800: ${colors.gray[800]};
        --color-gray-900: ${colors.gray[900]};
        --color-white: ${colors.white};
        --color-black: ${colors.black};
        --color-focus: ${colors.focus};
        --color-hover: ${colors.hover};
      }
      @media screen and (max-height: 300px) {
        .--hidden-on-sm-height {
          display: none;
        }
      }
      @media screen and (max-height: 500px) {
        .--hidden-on-md-height {
          display: none;
        }
      }
      `}</style>
      {children}
    </ThemeContext.Provider>
  );
};

export const useTheme = createUseContext('ThemeContext', ThemeContext);
